import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { URLSearchParams, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Router } from '@angular/router';
import { GlobalService } from '../global.service';
import { FileDetector } from 'selenium-webdriver';
@Injectable()
export class BankerBillsService {

  constructor(private http: Http, private router: Router) { }

  public listBills() {
    console.log('inside services');
    return this.http.get(environment.baseUrl + '/banker/invoiceDiscount?manual_invoice=false',
      GlobalService.getBankerHeadersWithoutCT()).map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }
  //   list report xls customerId,field
  public listReport(customerId) {
    console.log('inside services');
    return this.http.get(environment.baseUrl + '/report/get_report?customer_id='+customerId,
      GlobalService.getBankerHeadersWithoutCT()).map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }
  // status wise
  public listStatusReport(customerId,field) {
    console.log('inside services');
    return this.http.get(environment.baseUrl + '/report/get_report?customer_id='+customerId + '&field='+field,
      GlobalService.getBankerHeadersWithoutCT()).map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }
  //  
  public listOfStatement() {
    console.log('inside services');
    return this.http.get(environment.baseUrl + '/report/get_report',
      GlobalService.getBankerHeadersWithoutCT()).map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }
  //  overdue
  public overDueReport() {
    console.log('inside services');
    return this.http.get(environment.baseUrl + '/report/get_report?field=overdue',
      GlobalService.getBankerHeadersWithoutCT()).map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }
  // list of anchor
  public listSeller() {
    console.log('inside services');
    return this.http.get(environment.baseUrl + '/user/dsicounting_selller',
      GlobalService.getBankerHeadersWithoutCT()).map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }

  public listTransaction() {
    console.log('inside services list transactions');
    return this.http.get(environment.baseUrl + '/banker/invoiceDiscount/transaction',
      GlobalService.getBankerHeadersWithoutCT()).map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }

  public filterBill(bankerBillID: any) {
    console.log('inside services');
    const bankerInvoiceId = bankerBillID;
    const sellerId = sessionStorage.getItem('bankerInvoiceSellerId');
    const invoiceFlag = sessionStorage.getItem('bankerInvoiceFlag');
    const token = localStorage.getItem('currentUser');
    console.log('token', token);
    const headerToken = 'Bearer ' + token;
    console.log('hk', headerToken);
    const myHeaders = new Headers();
    myHeaders.append('Authorization', headerToken);
    let myParams = new URLSearchParams();
    myParams.append('sellerId', sellerId);
    myParams.append('manualInvoice', invoiceFlag);
    let options = new RequestOptions({ headers: myHeaders, params: myParams });
    return this.http.get(environment.baseUrl + '/banker/invoiceDiscount/' + bankerInvoiceId, options).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 400) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 401) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }
    });
  }

  public filterBillByBillRefNum(bankerBillID: any) {
    console.log('inside services');
    const bankerBillRefNo = bankerBillID;
    return this.http.get(environment.baseUrl + '/banker/invoiceDiscount/' + bankerBillRefNo,
      GlobalService.getBankerHeadersWithoutCT()).map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }

  public filterInvoice(invoiceId: any, sellerId: any) {
    console.log('inside services', invoiceId);
    const token = localStorage.getItem('currentUser');
    console.log('token', token);
    const headerToken = 'Bearer ' + token;
    console.log('hk', headerToken);
    const myHeaders = new Headers();
    myHeaders.append('Authorization', headerToken);
    let myParams = new URLSearchParams();
    myParams.append('sellerId', sellerId);
    let options = new RequestOptions({ headers: myHeaders, params: myParams });
    return this.http.get(environment.baseUrl + '/banker/invoice/manual/' + invoiceId, options).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 400) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 401) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }
    });
  }

  public onApproveBill(internalInvoiceId, invoiceFlag) {
    console.log(invoiceFlag);
    const sellerId = sessionStorage.getItem('bankerInvoiceSellerId');
    const data = {
      'sellerId': sellerId,
      'complianceCheck': 0,
      'invoiceId': internalInvoiceId,
      'status': 'Approved',
      'manualInvoice': invoiceFlag,
    };
    console.log('data', data);
    const body = JSON.stringify(data);
    console.log(body);
    return this.http.post(environment.baseUrl + '/banker/invoiceDiscount/lodgement', body,
      GlobalService.getHeaders()).map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }


  public onRejectBill(reason, internalInvoiceId, invoiceFlag) {
    const sellerId = sessionStorage.getItem('bankerInvoiceSellerId');
    const data = {
      'sellerId': sellerId,
      'complianceCheck': 1,
      'invoiceId': internalInvoiceId,
      'status': 'Rejected',
      'rejectionRemarks': reason.rejectionReason,
      'manualInvoice': invoiceFlag,

    };
    console.log('data', data);
    const body = JSON.stringify(data);
    console.log(body);
    return this.http.post(environment.baseUrl + '/banker/invoiceDiscount/lodgement', body,
      GlobalService.getHeaders()).map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }

  public getBillReferenceById(customer) {
    console.log('inside services');
    const billReferenceNum = customer.reference;
    return this.http.get(environment.baseUrl + '/banker/invoiceDiscount/' + billReferenceNum,
      GlobalService.getBankerHeadersWithoutCT()).map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }

  public onDiscounting(discountData) {
    const data = {
      'otherParty': discountData.otherParty,
      'amountFinanced': discountData.amtFinanced,
      'billReferenceNo': discountData.billRefNum,
      // 'marginRate': discountData.marginPercent,
      // 'numberOfDays': discountData.tenor
    };
    console.log('data', data);
    const body = JSON.stringify(data);
    console.log(body);
    return this.http.post(environment.baseUrl + '/banker/invoiceDiscount', body,
      GlobalService.getHeaders()).map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }

  public onLiquidating(liquidationData) {
    const data = {
      'billReferenceNo': liquidationData.billRefNum
    };
    console.log('data', data);
    const body = JSON.stringify(data);
    console.log(body);
    return this.http.put(environment.baseUrl + '/banker/invoiceDiscount', body,
      GlobalService.getHeaders()).map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }

  public getLRHash(fileId) {
    console.log('inside services');
    const invoiceId = fileId;
    const sellerId = sessionStorage.getItem('bankerViewLRCustomerId');
    const LRinvoiceFlag = sessionStorage.getItem('bankerViewLRinvoiceFlag');
    return this.http.get(environment.docUrl + '/swarm/docs/' + sellerId + '/' + invoiceId + '/' + LRinvoiceFlag + '/lorryReceipt',
      GlobalService.getHeaders()).map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }

  public getBOEHash(fileId) {
    console.log('inside services');
    const invoiceId = fileId;
    const sellerId = sessionStorage.getItem('bankerViewBOECustomerId');
    const BOEinvoiceFlag = sessionStorage.getItem('bankerViewBOEinvoiceFlag');
    return this.http.get(environment.docUrl + '/swarm/docs/' + sellerId + '/' + invoiceId + '/' + BOEinvoiceFlag + '/billOfExchange',
      GlobalService.getHeaders()).map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }

  public getOtherHash(fileId) {
    console.log('inside services');
    const invoiceId = fileId;
    const sellerId = sessionStorage.getItem('bankerViewOtherCustomerId');
    const OtherinvoiceFlag = sessionStorage.getItem('bankerViewOtherinvoiceFlag');
    return this.http.get(environment.docUrl + '/swarm/docs/' + sellerId + '/' + invoiceId + '/' + OtherinvoiceFlag + '/others',
      GlobalService.getHeaders()).map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }

  public filterBankerInvoice(bankerInvID: any) {
    console.log('inside services');
    const bankerInvoiceNo = bankerInvID;
    const sellerId = sessionStorage.getItem('bankerInvoiceSellerId');
    return this.http.get(environment.baseUrl + '/banker/invoice/' + sellerId + '/' + bankerInvoiceNo,
      GlobalService.getBankerHeadersWithoutCT()).map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }

  public getPIByID(proformaId) {
    console.log('inside services');
    const piId = proformaId;
    console.log('piId', piId);
    return this.http.get(environment.baseUrl + '/banker/proforma/' + piId,
      GlobalService.getHeaders()).map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }

  public addTransactionMaintenance(formdata) {
    console.log('txn maintenance fields', formdata);
    return this.http.post(environment.baseUrl + '/banker/invoiceDiscount/transaction',
      formdata, GlobalService.getHeaders()).map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }

  public onUpdateTxn(modifiedData, customerID) {
    const data = {
      "name": modifiedData.name,
      "FLDG": modifiedData.FLDG,
      "category": modifiedData.category,
      "customerId": customerID,
      "product": modifiedData.product,
      "tenure": modifiedData.tenure,
      "interestCalculation": modifiedData.interestCalculation,
      "platformFee": modifiedData.platformFee,
      "stampingCharges": modifiedData.stampingCharges,
      "insuranceCharges": modifiedData.insuranceCharges,
      "otherChanrges": modifiedData.otherChanrges,
      'fees': modifiedData.pfees,
      'interestRate': modifiedData.interestRate,
      "margin": modifiedData.margin,
      "ODC": modifiedData.ODC
    };
    console.log('data', data);
    const body = JSON.stringify(data);
    console.log(body);
    return this.http.put(environment.baseUrl + '/banker/invoiceDiscount/transaction', body,
      GlobalService.getHeaders()).map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }

  public onDeleteTxn(customerId) {
    console.log('txn maintenance fields', customerId);
    const token = localStorage.getItem('bankertoken');
    console.log('token', token);
    const headerToken = 'Bearer ' + token;
    console.log('hk', headerToken);
    const headers = new Headers({ 'Authorization': headerToken, 'Content-Type': 'application/json' });
    const options = {
      headers: new Headers({
        'Authorization': headerToken, 'Content-Type': 'application/json'
      }),
      body: {
        'customerId': customerId
      },
    };

    return this.http.delete(environment.baseUrl + '/banker/invoiceDiscount/transactions', options).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 400) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 401) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }
    });
  }

  // statement of account
  public paginationStatement(newOffset, limit) {
    console.log('pagination', newOffset, limit);
    const token = localStorage.getItem('currentUser');
    console.log('token', token);
    const headerToken = 'Bearer ' + token;
    console.log('hk', headerToken);
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', headerToken);
    return this.http.get(environment.baseUrl + '/report/get_report',
      {
        headers: headers, params: {
          offset: newOffset,
          limit: limit
        }
      })
      .map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }
  // 
  public paginationBill(newOffset, limit) {
    console.log('pagination', newOffset, limit);
    const token = localStorage.getItem('currentUser');
    console.log('token', token);
    const headerToken = 'Bearer ' + token;
    console.log('hk', headerToken);
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', headerToken);
    return this.http.get(environment.baseUrl + '/banker/invoiceDiscount?manual_invoice=false',
      {
        headers: headers, params: {
          offset: newOffset,
          limit: limit
        }
      })
      .map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  } 

  // 
  

  public previousPage(previousUrl) {
    console.log('on previous page', previousUrl);
    return this.http.get(environment.baseUrl + '/banker/invoiceDiscount?manual_invoice=false' + previousUrl, GlobalService.getHeaders())
      .map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }

  public NextPage(nextUrl, newOffset, limit) {
    console.log('on next page', nextUrl, newOffset, limit);
    const token = localStorage.getItem('currentUser');
    console.log('token', token);
    const headerToken = 'Bearer ' + token;
    console.log('hk', headerToken);
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', headerToken);
    return this.http.get(environment.baseUrl + '/banker/invoiceDiscount?manual_invoice=false',
      {
        headers: headers, params: {
          offset: newOffset,
          limit: limit
        }
      })
      .map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }
  // statement
  public previousPageStatement(previousUrl) {
    console.log('on previous page', previousUrl);
    return this.http.get(environment.baseUrl + '/report/get_report' + previousUrl, GlobalService.getHeaders())
      .map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }
  // 
  public NextStatementPage(nextUrl, newOffset, limit) {
    console.log('on next page', nextUrl, newOffset, limit);
    const token = localStorage.getItem('currentUser');
    console.log('token', token);
    const headerToken = 'Bearer ' + token;
    console.log('hk', headerToken);
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', headerToken);
    return this.http.get(environment.baseUrl + '/report/get_report',
      {
        headers: headers, params: {
          offset: newOffset,
          limit: limit
        }
      })
      .map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }
  // 

  public filterBillByURL(offset: any, limit: any) {
    console.log('href on services', offset, limit);
    const token = localStorage.getItem('currentUser');
    console.log('token', token);
    const headerToken = 'Bearer ' + token;
    console.log('hk', headerToken);
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', headerToken);
    return this.http.get(environment.baseUrl + '/banker/invoiceDiscount?manual_invoice=false', {
      headers: headers, params: {
        offset: offset,
        limit: limit
      }
    })
      .map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }
  // 
  public filterStatementByURL(offset: any, limit: any) {
    console.log('href on services', offset, limit);
    const token = localStorage.getItem('currentUser');
    console.log('token', token);
    const headerToken = 'Bearer ' + token;
    console.log('hk', headerToken);
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', headerToken);
    return this.http.get(environment.baseUrl + '/report/get_report', {
      headers: headers, params: {
        offset: offset,
        limit: limit
      }
    })
      .map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }

  public filterBillOffset() {
    console.log('offset');
    const token = localStorage.getItem('currentUser');
    console.log('token', token);
    const headerToken = 'Bearer ' + token;
    console.log('hk', headerToken);
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', headerToken);
    return this.http.get(environment.baseUrl + '/banker/invoiceDiscount?manual_invoice=false',
      {
        headers: headers, params: {
          offset: '0',
          limit: '10'
        }
      })
      .map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }

  public searchBill(search) {
    console.log('search', search.searchParam);
    console.log('offset', search.offsteParam);
    console.log('limit', search.limitParam);
    const token = localStorage.getItem('currentUser');
    console.log('token', token);
    const headerToken = 'Bearer ' + token;
    console.log('hk', headerToken);
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', headerToken);
    return this.http.get(environment.baseUrl + '/banker/invoiceDiscount?manual_invoice=false',
      {
        headers: headers, params: {
          offset: 0,
          limit: search.limitParam,
          search: search.searchParam
        }
      })
      .map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }

  // Get anchor by lender id
  public anchorList() {
    const lenderId = localStorage.getItem('bankerId')
    console.log('inside services');
    return this.http.get(environment.baseUrl + '/user/get_distributors_list_for_lenders/' + lenderId,
      GlobalService.getBankerHeadersWithoutCT()).map((response: Response) => {
        console.log(response.status);
        const user = response.json();
        user.responseStatus = response.status;
        // console.log(user);
        return user;
      }).catch((error) => {
        console.log('error', error);
        if (error.status === 500) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 400) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        } else if (error.status === 401) {
          console.log('status', error.status);
          const err = error.json();
          err.responseStatus = error.status;
          console.log('status', err.responseStatus);
          return Observable.throw(err);
        }
      });
  }
// on disburse
public onDisburse() {
 
  const orderId = sessionStorage.getItem('orderId');
  const billReferenceNo = sessionStorage.getItem('billReferenceNo')
  const data = {
    "orderId":orderId,
    "billReferenceNo": billReferenceNo
  };
  console.log('data', data);
  const body = JSON.stringify(data);
  console.log(body);
  return this.http.post(environment.baseUrl + '/banker/disbursement', body,
    GlobalService.getHeaders()).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 400) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 401) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }
    });
}
}
